module.exports = __webpack_public_path__ + "static/media/ios-stats.1db8674d.svg";